import type { RotasDoModulo } from '@/app/rotas';

import { TemplatesPage } from './TemplatesPage';

/** Templates de minuta, CCG e mensagem. */
export const rotas: RotasDoModulo = {
  menu: { '/templates': TemplatesPage },
};
